import React, { useEffect } from "react";

const Congratulations = () =>{

    const lang = document.documentElement.lang === "it"

    useEffect(()=>{ 
        document.querySelectorAll('.svg-trigger').forEach(element => element.style.fill = "black" );
        document.documentElement.style.setProperty("--mainColor", "black");
    },[])

    return(
        <section className="full-height step-easter-egg step-end position-relative">
            <div className="container-fluid full-height">
                <div className="row full-height d-flex align-items-center">
                    <div className="col-md-7 m-auto">
                        <div className="p-sm-5 py-5 px-3 text-center bg-white">
                            <div className="m-sm-4">
                                <h1 className="text-color mb-4 pb-md-2 ">{lang ? "Hai scoperto tutti gli Easter egg!" : "You’ve discovered all the Ester eggs!"}</h1>
                                <p className="mb-5">
                                    { lang ? "Continua il viaggio tra gli scatti e le storie del Calendario Lavazza 2023." : "The journey continues through the 2023 Lavazza Calendar’s photos and stories"}
                                </p>
                                <a href={lang ? "it.html" : "en.html"} className="btn btn-outline-dark btn-lg btn-lavazza">{lang ? "TORNA AL CALENDARIO" : "BACK TO" +
                                " CALENDAR"}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="4" height="8" viewBox="0 0 4 8">
                                        <path id="Poligono_2" data-name="Poligono 2" d="M4,0,8,4H0Z" transform="translate(4) rotate(90)" />
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>  
    )
}

export default Congratulations